export const commonTransitions = {
  duration: {
    shortest: 150,
    // shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195,

    fancy: 500,
  },
};

export const commonTypography = {
  allVariants: {
    // fontFamily: "roboto",
    // fontFamily: "lato",
    // fontFamily: "montserrat",
    fontFamily: "Helvetica",
  },
  boldHeaderText: {
    fontWeight: "700",
    fontSize: 14,
  },
};

const extraPalettes = [
  { name: "green", primary: "#24695c", secondary: "#ba895d" },
  { name: "orange", primary: "#d97f3d", secondary: "#f25f4c" },
  { name: "blue", primary: "#168eea", secondary: "#90b4cd" },
  { name: "purple", primary: "#665ed5", secondary: "#d1d1e9" },
  { name: "bluegreen", primary: "#3a9aa8", secondary: "#984ff3" },
  { name: "magenta", primary: "#7951aa", secondary: "#72757D" },
];
export default extraPalettes;
